import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BreadCrumb.js");
;
import(/* webpackMode: "eager", webpackExports: ["JsonLdScript"] */ "/app/src/components/JsonLdScript.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pageBuilder/PageBuilderClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/bus/HeaderSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VirtualPvEvent.js");
;
import(/* webpackMode: "eager", webpackExports: ["componentRegistry","itemPropMapping"] */ "/app/src/configs/bus/landing-pages/city-pages/registry.js");
;
import(/* webpackMode: "eager", webpackExports: ["componentRegistry","itemPropMapping"] */ "/app/src/configs/bus/landing-pages/company-pages/registry.js");
;
import(/* webpackMode: "eager", webpackExports: ["componentRegistry","itemPropMapping"] */ "/app/src/configs/bus/landing-pages/home/registry.js");
;
import(/* webpackMode: "eager", webpackExports: ["componentRegistry","itemPropMapping"] */ "/app/src/configs/bus/landing-pages/route-pages/registry.js");
;
import(/* webpackMode: "eager" */ "/app/src/configs/bus/landing-pages/styles/landing-pages.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["componentRegistry","itemPropMapping"] */ "/app/src/configs/bus/landing-pages/terminal-pages/registry.js");
